import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'
import { setPreferences } from '../../../modules/preferences/actions/creators'
import { setDevice } from '../../../modules/device/actions/creators'
import { setPreferenceIds } from '../../../modules/profile/actions/creators'

import {
  doGetPreferences,
  doSubmitPreferences,
} from '../../../controllers/Registration'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const { auth, registration, profile, preferences, device } = reduxState
  const { accessToken, redirectAfterAuth } = auth
  const { primaryInfo } = profile
  const { step } = registration
  const { basePreferences } = preferences
  const { browser } = device

  return {
    step,
    accessToken,
    primaryInfo,
    basePreferences,
    redirectAfterAuth,
    doGetPreferences,
    doSubmitPreferences,
    browser,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      setDevice,
      setPreferences,
      saveAccessToken,
      setPreferenceIds,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
